import React, { createContext, useState, useContext, useEffect } from 'react';

const TrainingAuthContext = createContext();

export const useTrainingAuth = () => {
  const context = useContext(TrainingAuthContext);
  if (!context) {
    throw new Error('useTrainingAuth must be used within a TrainingAuthProvider');
  }
  return context;
};

export const TrainingAuthProvider = ({ children }) => {
  const [trainingUser, setTrainingUser] = useState(null);
  const [isTrainingAuthenticated, setIsTrainingAuthenticated] = useState(false);
  const [loadingTraining, setLoadingTraining] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('training_token');
    const userData = localStorage.getItem('training_user');

    if (token && userData) {
      try {
        const parsed = JSON.parse(userData);
        setTrainingUser(parsed);
        setIsTrainingAuthenticated(true);
      } catch {
        localStorage.removeItem('training_token');
        localStorage.removeItem('training_refreshToken');
        localStorage.removeItem('training_user');
      }
    }
    setLoadingTraining(false);
  }, []);

  const trainingLogin = (accessToken, refreshToken, userData) => {
    localStorage.setItem('training_token', accessToken);
    localStorage.setItem('training_refreshToken', refreshToken);
    localStorage.setItem('training_user', JSON.stringify(userData));
    setTrainingUser(userData);
    setIsTrainingAuthenticated(true);
  };

  const trainingLogout = () => {
    localStorage.removeItem('training_token');
    localStorage.removeItem('training_refreshToken');
    localStorage.removeItem('training_user');
    setTrainingUser(null);
    setIsTrainingAuthenticated(false);
  };

  const updateTrainingUser = (updatedUser) => {
    setTrainingUser(updatedUser);
    localStorage.setItem('training_user', JSON.stringify(updatedUser));
  };

  return (
    <TrainingAuthContext.Provider value={{
      trainingUser,
      isTrainingAuthenticated,
      loadingTraining,
      trainingLogin,
      trainingLogout,
      updateTrainingUser,
    }}>
      {children}
    </TrainingAuthContext.Provider>
  );
};
